import './quiz';

/* ============================================================
   Landing "Employment Law Solicitors" (UK) — chat-bot hero only
   WP theme: enqueued from functions.php (theme_assets()).
   window.LEAD_CONFIG is printed into wp_head by
   theme-functions.php (maksim_print_lead_config()).

   The site ships the scripted bot-chat hero (#botLeadForm) from
   front-page.php. The plain-form hero code below (askFlow(),
   #heroLeadForm) is inherited from the original two-variant source
   and simply no-ops now that #heroLeadForm isn't on the page —
   harmless to keep, safe to delete later if you want a leaner file.

   What this file does:
     · keeps UTM tags for the whole session and attaches them to the lead;
     · runs the scripted bot intake (role → area → timing, then a
       callback number) — see §6b;
     · lets an issue card ("Unfair Dismissal" …) qualify the lead too;
     · phone mask + country code picker + validation;
     · optional reCAPTCHA v3 check before the lead is sent (see §9) —
       fully skipped when the theme has no reCAPTCHA keys configured;
     · sends the lead as JSON to LEAD_CONFIG.endpoint, or lets the form
       do a regular POST when nativeSubmit is on.

   Configured through window.LEAD_CONFIG — see functions.php /
   theme-functions.php and README.md.
   ============================================================ */
(function () {
  'use strict';

  var CFG = Object.assign({
    endpoint: '',
    partner: 'employment-law',
    phone: '+447418379170',
    keywordParam: 'utm_term',
    keywordInTitle: false,
    keywordMaxLength: 90,
    nativeSubmit: false,
    thanksUrl: 'thanks.html',
    privacyUrl: 'privacy.html'
  }, window.LEAD_CONFIG || {});

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];
  var STORE_KEY = 'clm_employment_utm';

  /* ============================================================
     1. UTM tags: read from the URL, remember for the session
     ============================================================ */
  function readUtm() {
    var q = new URLSearchParams(location.search);
    var fromUrl = {}, has = false;
    UTM_KEYS.forEach(function (k) {
      var v = q.get(k);
      if (v !== null && v !== '') { fromUrl[k] = v; has = true; }
    });
    if (has) {
      try { localStorage.setItem(STORE_KEY, JSON.stringify(fromUrl)); } catch (e) { }
      return fromUrl;
    }
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}'); } catch (e) { return {}; }
  }

  /* The ad keyword comes from the URL, i.e. untrusted data:
     text only, no HTML, length-capped, unexpanded macros dropped. */
  function cleanKeyword(raw) {
    if (!raw) return '';
    var v = String(raw).replace(/\+/g, ' ');
    try { v = decodeURIComponent(v); } catch (e) { }
    v = v.replace(/[<>]/g, ' ')
      .replace(/[\u0000-\u001F\u007F]/g, ' ')       // control characters
      .replace(/\s+/g, ' ')
      .trim();
    if (!v) return '';
    if (/[{}]/.test(v)) return '';                     // {keyword} never expanded
    if (/^https?:\/\//i.test(v)) return '';            // never print a link
    if (v.length > CFG.keywordMaxLength) return '';
    if (!/[a-zA-Z\u0400-\u04FF]/.test(v)) return '';    // digits only — not a headline
    return v.charAt(0).toUpperCase() + v.slice(1);
  }

  var utm = readUtm();
  var keyword = cleanKeyword(utm[CFG.keywordParam]);

  /* ============================================================
     2. Headline. The brief fixes it, so the ad keyword only goes
        into the lead — unless keywordInTitle is switched on.
     ============================================================ */
  (function applyTitle() {
    var kw = document.querySelector('.js-h1-keyword');
    var def = document.querySelector('.js-h1-default');
    if (!kw || !def) return;
    if (CFG.keywordInTitle && keyword) {
      kw.textContent = keyword;      // textContent, never innerHTML
      kw.hidden = false;
      def.hidden = true;
      document.title = keyword + ' — Consultant';
      var md = document.querySelector('meta[property="og:title"]');
      if (md) md.setAttribute('content', keyword);
    }
  })();

  /* ============================================================
     3. Hotline number from the config
     ============================================================ */
  (function applyPhone() {
    var digits = String(CFG.phone || '').replace(/[^\d+]/g, '');
    if (!digits) return;
    var pretty = digits;
    var uk = digits.match(/^\+44(\d{4})(\d{6})$/);
    var us = digits.match(/^\+1(\d{3})(\d{3})(\d{4})$/);
    var ua = digits.match(/^\+380(\d{2})(\d{3})(\d{2})(\d{2})$/);
    if (uk) pretty = '+44 ' + uk[1] + ' ' + uk[2];
    else if (us) pretty = '+1 (' + us[1] + ') ' + us[2] + '-' + us[3];
    else if (ua) pretty = '+380 ' + ua[1] + ' ' + ua[2] + ' ' + ua[3] + ' ' + ua[4];
    document.querySelectorAll('.js-phone-link').forEach(function (a) { a.href = 'tel:' + digits; });
    document.querySelectorAll('.js-phone-text').forEach(function (el) { el.textContent = pretty; });
  })();

  /* ============================================================
     4. Privacy Policy link — the consent line and footer point at
        whatever page the backend configures.
     ============================================================ */
  (function applyPrivacy() {
    if (CFG.privacyUrl) {
      document.querySelectorAll('.js-privacy-link').forEach(function (a) { a.href = CFG.privacyUrl; });
    }
  })();

  /* ============================================================
     5. Forms: hidden fields and the selected-issue chip
     ============================================================ */
  var forms = [].slice.call(document.querySelectorAll('.js-lead-form'));

  /* Issue picked with a card — overrides utm_term for that lead */
  var pickedDirection = '';

  function setHidden(form, name, value) {
    var el = form.querySelector('input[type="hidden"][name="' + name + '"]');
    if (el) el.value = value == null ? '' : value;
  }

  function directionOf(form) {
    /* the bot has already chosen a category — trust it over everything else */
    if (form && form.dataset.dirLocked === '1') {
      var hd = form.querySelector('input[name="direction"]');
      if (hd && hd.value) return { value: hd.value, source: 'bot' };
    }
    if (pickedDirection) return { value: pickedDirection, source: 'service' };
    var q = form.querySelector('.js-question');
    var qv = q ? q.value.trim() : '';
    if (qv) return { value: qv, source: 'question' };
    if (keyword) return { value: keyword, source: 'utm_term' };
    return { value: '', source: '' };
  }

  forms.forEach(function (form) {
    /* hidden fields — so both a JSON lead and a plain POST carry everything */
    UTM_KEYS.forEach(function (k) { setHidden(form, k, utm[k] || ''); });
    setHidden(form, 'referer', document.referrer || location.href);
    setHidden(form, 'partner', CFG.partner);

    /* chip with the picked issue — appears after a card click */
    var chip = document.createElement('div');
    chip.className = 'lf-dir';
    chip.hidden = true;
    chip.innerHTML = '<span class="lf-dir__label">Issue:</span> <b class="lf-dir__val"></b>' +
      '<button type="button" class="lf-dir__x" aria-label="Remove issue">×</button>';
    form.insertBefore(chip, form.firstElementChild);
    chip.querySelector('.lf-dir__x').addEventListener('click', function () {
      pickedDirection = '';
      syncDirectionChips();
      document.querySelectorAll('.pcard.is-picked').forEach(function (c) { c.classList.remove('is-picked'); });
    });
  });

  function syncDirectionChips() {
    forms.forEach(function (form) {
      var chip = form.querySelector('.lf-dir');
      if (!chip) return;
      chip.hidden = !pickedDirection;
      var val = chip.querySelector('.lf-dir__val');
      /* textContent: the issue name never goes into markup as HTML */
      if (val) val.textContent = pickedDirection;
    });
  }

  /* ============================================================
     6. Hero chat field: question first, contacts after
     ============================================================ */
  (function askFlow() {
    var form = document.getElementById('heroLeadForm');
    if (!form) return;
    var step2 = form.querySelector('.js-ask-step2');
    var input = form.querySelector('.js-question');
    var go = form.querySelector('.js-ask-go');
    if (!step2 || !input) return;

    function openStep2(focusPhone) {
      if (!step2.hidden) return;
      step2.hidden = false;
      if (focusPhone && window.matchMedia('(min-width: 700px)').matches) {
        var name = form.querySelector('[name="customer_name"]');
        if (name) name.focus({ preventScroll: true });
      }
    }

    function tryOpen() {
      if (input.value.trim().length < 5 && !pickedDirection) {
        setErr(form, 'question', 'Please describe your question in a few words');
        input.focus();
        return;
      }
      clearErr(form, 'question');
      openStep2(true);
    }

    if (go) go.addEventListener('click', tryOpen);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); tryOpen(); }
    });
    /* typing alone already reveals the contacts — one less click */
    input.addEventListener('input', function () {
      clearErr(form, 'question');
      if (input.value.trim().length >= 5) openStep2(false);
    });

    /* expose it so the issue cards can open the step too */
    form.__openStep2 = openStep2;
  })();

  /* ============================================================
     6b. Bot intake (variant 2 only — #botLeadForm)
         A scripted assistant: the typed problem starts a short chat,
         the bot asks a few qualifying questions, then reveals the
         callback step. It gives NO legal advice — a person calls back.
     ============================================================ */
  (function botFlow() {
    var form = document.getElementById('botLeadForm');
    if (!form) return;
    var start = form.querySelector('.js-bot-start');
    var input = form.querySelector('.js-question');
    var go = form.querySelector('.js-bot-go');
    var chat = form.querySelector('.js-botchat');
    var contact = form.querySelector('.js-bot-contact');
    if (!start || !input || !go || !chat || !contact) return;

    /* opt[0] = label shown to the user, opt[1] = value stored on the lead */
    var STEPS = [
      {
        key: 'role', q: 'Thanks. Are you an employee or an employer?',
        opts: [['Employee', 'Employee'], ['Employer', 'Employer']]
      },
      {
        key: 'area', q: 'Which area is closest to your situation?',
        opts: [
          ['Unfair dismissal', 'Unfair Dismissal'],
          ['Unpaid wages', 'Unpaid Wages & Salary Disputes'],
          ['Discrimination', 'Workplace Discrimination'],
          ['Redundancy', 'Redundancy & Restructuring'],
          ['Settlement agreement', 'Settlement Agreements'],
          ['Something else', 'Employment law — general']
        ]
      },
      {
        key: 'timing', q: 'When did this happen?',
        opts: [
          ["It's ongoing", 'Ongoing'],
          ['Within the last month', 'Within the last month'],
          ['1–3 months ago', '1–3 months ago'],
          ['More than 3 months ago', 'More than 3 months ago']
        ]
      }
    ];

    var answers = {}, idx = 0, quickEl = null, reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function scroll() { chat.scrollTop = chat.scrollHeight; }
    function bubble(text, who) {
      var d = document.createElement('div');
      d.className = 'bmsg bmsg--' + who;
      d.textContent = text;              /* textContent: never inject as HTML */
      chat.appendChild(d); scroll(); return d;
    }
    function typing(cb) {
      if (reduce) { cb(); return; }
      var t = document.createElement('div');
      t.className = 'bmsg bmsg--bot bmsg--typing';
      t.innerHTML = '<span></span><span></span><span></span>';
      chat.appendChild(t); scroll();
      setTimeout(function () { t.remove(); cb(); }, 620);
    }
    function quick(step) {
      var w = document.createElement('div');
      w.className = 'bquick';
      step.opts.forEach(function (o) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'bchip'; b.textContent = o[0];
        b.addEventListener('click', function () { choose(step, o); });
        w.appendChild(b);
      });
      chat.appendChild(w); scroll(); return w;
    }
    function ask() {
      if (idx >= STEPS.length) { finish(); return; }
      var step = STEPS[idx];
      typing(function () { bubble(step.q, 'bot'); quickEl = quick(step); });
    }
    function choose(step, o) {
      if (quickEl) { quickEl.remove(); quickEl = null; }
      bubble(o[0], 'user');
      answers[step.key] = o[1];
      idx++; ask();
    }
    function finish() {
      typing(function () {
        bubble('Thanks. Leave your name and number and a member of the team will call you back to talk through your options.', 'bot');
        setHidden(form, 'direction', answers.area || 'Employment law — general');
        setHidden(form, 'direction_source', 'bot');
        setHidden(form, 'qualifiers',
          'Role: ' + (answers.role || '—') + '; Area: ' + (answers.area || '—') + '; Timing: ' + (answers.timing || '—'));
        form.dataset.dirLocked = '1';
        contact.hidden = false;
        var ph = contact.querySelector('.js-lf-phone');
        if (ph && window.matchMedia('(min-width: 700px)').matches) ph.focus({ preventScroll: true });
      });
    }
    function begin() {
      var v = input.value.trim();
      if (v.length < 5) {
        setErr(form, 'question', 'Please describe your problem in a few words');
        input.focus(); return;
      }
      clearErr(form, 'question');
      start.hidden = true; chat.hidden = false;
      bubble(v, 'user');
      idx = 0; ask();
    }

    go.addEventListener('click', begin);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); begin(); }
    });
  })();

  /* ============================================================
     7. Issue cards
     ============================================================ */
  document.querySelectorAll('.js-pick').forEach(function (card) {
    card.addEventListener('click', function () {
      var dir = card.getAttribute('data-dir') || '';
      var again = card.classList.contains('is-picked');
      document.querySelectorAll('.pcard.is-picked').forEach(function (c) { c.classList.remove('is-picked'); });
      pickedDirection = again ? '' : dir;
      if (!again) card.classList.add('is-picked');
      syncDirectionChips();
      if (again) return;

      /* prefill the free-text field of every form that is still empty */
      document.querySelectorAll('.js-question').forEach(function (q) {
        if (!q.value.trim()) q.value = dir + ': ';
      });
      var hero = document.getElementById('heroLeadForm');
      if (hero && hero.__openStep2) hero.__openStep2(false);

      scrollToEl(document.getElementById('findbox'), function () {
        var f = document.querySelector('#findLeadForm [name="customer_name"]');
        if (f && window.matchMedia('(min-width: 700px)').matches) f.focus({ preventScroll: true });
      });
    });
  });

  /* ============================================================
     8. Phone: mask + country code
     ============================================================ */
  function groupsOf(input) {
    var g = (input.getAttribute('data-groups') || '').trim();
    return g ? g.split(',').map(Number) : [];
  }
  function maxDigits(input) { return parseInt(input.getAttribute('data-max'), 10) || 15; }

  function formatDigits(digits, groups) {
    if (!groups.length) return digits;
    var out = [], i = 0;
    for (var k = 0; k < groups.length && i < digits.length; k++) {
      out.push(digits.slice(i, i + groups[k]));
      i += groups[k];
    }
    if (i < digits.length) out.push(digits.slice(i));
    return out.filter(Boolean).join(' ');
  }
  function placeholderFor(groups) {
    if (!groups.length) return '________';
    return groups.map(function (n) { return new Array(n + 1).join('_'); }).join(' ') + ' *';
  }
  /* People often type the trunk zero (0 50 …) — for codes whose national
     number has none, drop it automatically. */
  function stripTrunkZero(digits, form) {
    var ccEl = form && form.querySelector('.js-lf-cc-code');
    var cc = ccEl ? ccEl.textContent.trim() : '';
    if ((cc === '+380' || cc === '+48' || cc === '+44') && digits.charAt(0) === '0') return digits.replace(/^0+/, '');
    return digits;
  }

  document.querySelectorAll('.js-lf-phone').forEach(function (input) {
    input.addEventListener('input', function () {
      var digits = (input.value.match(/\d/g) || []).join('');
      digits = stripTrunkZero(digits, input.form).slice(0, maxDigits(input));
      input.value = formatDigits(digits, groupsOf(input));
      input.classList.remove('is-bad');
      clearErr(input.form, 'phone');
    });
    input.addEventListener('keypress', function (e) {
      if (e.key && e.key.length === 1 && !/\d/.test(e.key)) e.preventDefault();
    });
  });

  document.querySelectorAll('.js-lf-cc').forEach(function (cc) {
    var btn = cc.querySelector('.js-lf-cc-btn');
    var list = cc.querySelector('.js-lf-cc-list');
    var flag = cc.querySelector('.js-lf-cc-flag');
    var code = cc.querySelector('.js-lf-cc-code');
    var input = cc.closest('.lf-phone').querySelector('.js-lf-phone');
    var form = cc.closest('form');

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = list.hidden;
      document.querySelectorAll('.js-lf-cc-list').forEach(function (l) { l.hidden = true; });
      list.hidden = !willOpen;
      btn.setAttribute('aria-expanded', String(willOpen));
    });

    list.querySelectorAll('.lf-cc-opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        code.textContent = opt.getAttribute('data-code');
        flag.src = opt.getAttribute('data-flag');
        input.setAttribute('data-max', opt.getAttribute('data-max'));
        input.setAttribute('data-groups', opt.getAttribute('data-groups'));
        setHidden(form, 'country_code', opt.getAttribute('data-country') || '');
        var digits = (input.value.match(/\d/g) || []).join('').slice(0, maxDigits(input));
        input.value = formatDigits(digits, groupsOf(input));
        input.placeholder = placeholderFor(groupsOf(input));
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        input.focus();
      });
    });
  });
  document.addEventListener('click', function () {
    document.querySelectorAll('.js-lf-cc-list').forEach(function (l) { l.hidden = true; });
  });

  /* ============================================================
     9. reCAPTCHA v3 (optional).
     window.MAKSIM_RECAPTCHA is printed by theme-functions.php only
     when the theme has ADVOKAT_RECAPTCHA_SITE_KEY and
     ADVOKAT_RECAPTCHA_SECRET_KEY set (empty values = local/dev,
     the check is fully disabled). The token is verified server-side
     through admin-ajax.php (maksim_verify_recaptcha) — the secret
     key never reaches the browser.
     ============================================================ */
  var RECAPTCHA = window.MAKSIM_RECAPTCHA || { enabled: false };

  function withRecaptcha(done) {
    if (!RECAPTCHA.enabled || !window.grecaptcha || !RECAPTCHA.siteKey) {
      done('');
      return;
    }
    grecaptcha.ready(function () {
      grecaptcha.execute(RECAPTCHA.siteKey, { action: 'lead_submit' }).then(function (token) {
        fetch(RECAPTCHA.ajaxUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'action=maksim_verify_recaptcha&nonce=' + encodeURIComponent(RECAPTCHA.nonce) +
            '&token=' + encodeURIComponent(token)
        }).then(function (r) { return r.json(); }).then(function (res) {
          done((res && res.success) ? token : false);
        }).catch(function () { done(token); }); /* network hiccup on verify — don't block the lead */
      }, function () { done(''); });
    });
  }

  /* ============================================================
     10. Validation and submit
     ============================================================ */
  function setErr(form, field, msg) {
    if (!form) return;
    var input = form.querySelector('[name="' + field + '"]');
    var err = form.querySelector('.lf-err[data-for="' + field + '"]');
    if (input) input.classList.toggle('is-bad', !!msg);
    if (err) { err.textContent = msg || ''; err.classList.toggle('is-on', !!msg); }
  }
  function clearErr(form, field) { setErr(form, field, ''); }

  function submitLead(lead) {
    console.info('[lead]', lead);
    try {
      var arr = JSON.parse(localStorage.getItem('clm_employment_leads') || '[]');
      arr.push(lead);
      localStorage.setItem('clm_employment_leads', JSON.stringify(arr.slice(-50)));
    } catch (e) { }
    if (CFG.endpoint) {
      try {
        fetch(CFG.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(lead),
          keepalive: true   /* survives the redirect to the thanks page */
        }).catch(function () { });
      } catch (e) { }
    }
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'generate_lead', lead_source: lead.source, lead_direction: lead.direction });
    }
  }

  forms.forEach(function (form) {
    form.querySelectorAll('.lf-input').forEach(function (inp) {
      inp.addEventListener('input', function () { clearErr(form, inp.name); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var nameEl = form.querySelector('[name="customer_name"]');
      var phone = form.querySelector('[name="phone"]');
      var qEl = form.querySelector('.js-question');
      var ccEl = form.querySelector('.js-lf-cc-code');
      var cc = ccEl ? ccEl.textContent.trim() : '+44';
      var digits = (phone.value.match(/\d/g) || []).join('');
      var need = maxDigits(phone);
      var ok = true;

      /* Name is optional — the brief only requires a way to call back */

      if (!digits.length) {
        setErr(form, 'phone', 'Please enter your phone number'); ok = false;
      } else if (cc === '+' ? digits.length < 7 : digits.length !== need) {
        setErr(form, 'phone', 'The number must contain ' + (cc === '+' ? 'at least 7' : need) + ' digits'); ok = false;
      } else clearErr(form, 'phone');

      /* The question is what qualifies the lead — required unless an
         issue card was picked. */
      if (qEl && !pickedDirection) {
        if (qEl.value.trim().length < 5) {
          setErr(form, 'question', 'Please describe your question in a few words'); ok = false;
        } else clearErr(form, 'question');
      }

      if (!ok) {
        var bad = form.querySelector('.lf-input.is-bad');
        if (bad) bad.focus();
        return;
      }

      var dir = directionOf(form);
      setHidden(form, 'direction', dir.value);
      setHidden(form, 'direction_source', dir.source);

      /* Plain POST mode: everything already sits in the hidden fields. */
      if (CFG.nativeSubmit && form.getAttribute('action')) {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'generate_lead',
            lead_source: form.getAttribute('data-source') || form.id,
            lead_direction: dir.value
          });
        }
        form.submit();
        return;
      }

      /* Reference for the post-submit qualification quiz: the same id
         goes into the lead and into sessionStorage, so the thanks page
         can attach its answers to THIS lead (no new lead is created). */
      var leadRef = 'L-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
      try { sessionStorage.setItem('clm_employment_lead_ref', leadRef); } catch (err) { }

      withRecaptcha(function (tokenOrFalse) {
        if (tokenOrFalse === false) {
          setErr(form, 'phone', 'We could not confirm you are not a robot. Please try again.');
          return;
        }

        submitLead({
          lead_ref: leadRef,
          source: form.getAttribute('data-source') || form.id,
          partner: CFG.partner,
          customer_name: nameEl ? nameEl.value.trim() : '',
          phone: cc + ' ' + phone.value.trim(),
          country_code: (form.querySelector('[name="country_code"]') || {}).value || '',
          direction: dir.value,
          direction_source: dir.source,
          question: qEl ? qEl.value.trim() : '',
          qualifiers: (form.querySelector('[name="qualifiers"]') || {}).value || '',
          keyword: keyword,
          utm: utm,
          referer: document.referrer || '',
          page: location.href,
          ts: new Date().toISOString(),
          /* reCAPTCHA v3 token — empty when the check is disabled (no keys) */
          recaptcha_token: tokenOrFalse || ''
        });

        /* Per the qualification brief the thank-you is a separate page
           with 4 follow-up questions — not an inline message. */
        location.href = CFG.thanksUrl || 'thanks.html';
      });
    });
  });

  /* ============================================================
     11. Small page behaviour
     ============================================================ */
  function scrollToEl(target, after) {
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset - 74;
    window.scrollTo({ top: top, behavior: 'smooth' });
    if (after) setTimeout(after, 600);
  }

  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (!id || id === '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      scrollToEl(target, function () {
        if (id === '#askbox') {
          var q = document.querySelector('#heroLeadForm .js-question');
          if (q && window.matchMedia('(min-width: 700px)').matches) q.focus({ preventScroll: true });
        } else if (id === '#lead') {
          var f = document.querySelector('#mainLeadForm [name="customer_name"]');
          if (f && window.matchMedia('(min-width: 700px)').matches) f.focus({ preventScroll: true });
        }
      });
    });
  });

  /* mobile CTA bar: shown once the hero form has left the screen */
  var mcta = document.getElementById('mobileCta');
  var heroForm = document.querySelector('.js-hero-form');   /* form OR bot hero */
  var leadSection = document.getElementById('lead');
  if (mcta && heroForm && 'IntersectionObserver' in window) {
    var heroVisible = true, leadVisible = false;
    var sync = function () { mcta.classList.toggle('is-on', !heroVisible && !leadVisible); };
    new IntersectionObserver(function (en) { heroVisible = en[0].isIntersecting; sync(); },
      { threshold: 0.15 }).observe(heroForm);
    if (leadSection) {
      new IntersectionObserver(function (en) { leadVisible = en[0].isIntersecting; sync(); },
        { threshold: 0.2 }).observe(leadSection);
    }
  }

  /* real header height into a CSS variable */
  var header = document.querySelector('header.site');
  function setHdr() {
    if (header) document.documentElement.style.setProperty('--hdr-h', header.offsetHeight + 'px');
  }
  setHdr();
  window.addEventListener('resize', setHdr);
  window.addEventListener('load', setHdr);
})();